import { render } from "./navbarTwoHeader.vue?vue&type=template&id=fe0ca288"
import script from "./navbarTwoHeader.vue?vue&type=script&lang=js"
export * from "./navbarTwoHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__